module.exports = __webpack_public_path__ + "static/media/29a0293f-0dfa-490c-b201-61dddecfbd97_1.c06488bdf16b627c07faf2ecbd5b051d.e70caeb9.png";